var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementEzeth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.727051,
    y: 0.5,
    width: 90.5455,
    height: 90.5455,
    rx: 45.2727,
    fill: "#C4FF61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8838 21.9734L45.8838 38.7037L61.6593 47.553L45.8838 21.9734Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3502 58.2257L46.3502 70.2303L61.6683 49.4045L46.3502 58.2257Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8101 38.5631L45.8101 56.0687L61.741 47.5531L45.8101 38.5631Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9654 21.9734L45.9654 38.7037L30.0345 47.553L45.9654 21.9734Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3436 58.2257L45.3436 70.2303L30.0255 49.4045L45.3436 58.2257Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8833 38.5631L45.8833 56.0687L29.9524 47.5531L45.8833 38.5631Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementEzeth);
export default __webpack_public_path__ + "static/media/movement-ezeth.5c7fd9c4c52e5d23b35fb8ff960de8f3.svg";
export { ForwardRef as ReactComponent };